module.exports = __webpack_public_path__ + "static/produto1-5b99dd4edea21d73fd214d7c55a8f84c.jpg";